export const BOOKING_URL = "https://link.sendlink.co/qr/Dv7nXiREp1TF";

export const CoachInvite = () => (
  <div className="avoid-break flex items-center gap-3 rounded-xl border border-[#1F4266]/20 bg-[#1F4266]/5 p-3 print:gap-2 print:p-2" data-testid="report-coach-invite">
    <img src="/schedule-qr.png" alt="QR code to schedule a coaching call" className="h-20 w-20 shrink-0 print:h-14 print:w-14" data-testid="report-coach-qr" />
    <div className="text-xs leading-snug text-slate-700">
      <div className="font-display text-sm font-bold text-[#1F4266]">Want one-on-one support?</div>
      Scan to schedule a coaching call to talk through your results and plan your next steps.
      <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="no-print mt-1 block font-semibold text-[#1F4266] underline" data-testid="report-coach-link">
        Schedule a call
      </a>
    </div>
  </div>
);
